import { type TypedUseSelectorHook, useSelector } from 'react-redux'
import type { RootState } from 'reduxStore'

// https://redux.js.org/tutorials/typescript-quick-start#define-typed-hooks
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
